// Home page SEO
export const HOME_SEO = {
  title: 'Find Verified PG Accommodation Near You | Zero Brokerage | AapkaPG',
  description: 'Search, compare & book verified PGs across India for boys, girls, students and professionals. Real photos, zero brokerage, instant booking on AapkaPG.',
  canonicalUrl: 'https://aapkapg.com/',
  keywords: ['PG accommodation', 'PG in Delhi', 'hostel', 'rental', 'student housing', 'paying guest', 'girls PG', 'boys PG']
};

// Location-specific SEO configurations
const LOCATION_SEO_CONFIG = {
  'karol bagh': {
    title: (count) => `${count} PG in Karol Bagh, Central Delhi | Boys & Girls PG - AapkaPG`,
    description: (count) => `Verified PGs in Karol Bagh, Central Delhi, Near Karol Bagh Metro & Ajmal Khan Road market. ${count} Boys & girls PG for students and professionals. No Brokerage`,
    canonicalUrl: 'https://aapkapg.com/pg-in-karol-bagh-central-delhi-pppfr',
    keywords: ['Karol Bagh PG', 'PG in Karol Bagh', 'Central Delhi PG', 'boys PG Karol Bagh', 'girls PG Karol Bagh']
  },
  'mukherjee nagar': {
    title: (count) => `${count} PG in Mukherjee Nagar, Delhi | Near DU & UPSC Coaching Hub - AapkaPG`,
    description: (count) => `Verified PGs in Mukherjee Nagar for UPSC aspirants, DU students & professionals near coaching centres and GTB Nagar Metro. ${count} PGs available. Zero brokerage.`,
    canonicalUrl: 'https://aapkapg.com/pg-in-mukherjee-nagar-north-west-delhi-pppfr',
    keywords: ['Mukherjee Nagar PG', 'PG in Mukherjee Nagar', 'UPSC PG', 'DU PG', 'coaching hub PG']
  },
  'delhi': {
    title: (count) => `${count} Verified PG in Delhi | Zero Brokerage PG for Boys & Girls - AapkaPG`,
    description: (count) => `Explore ${count} verified PGs in Delhi for boys, girls, students & professionals. Compare rooms by budget & amenities with real photos. Zero brokerage, instant booking.`,
    canonicalUrl: 'https://aapkapg.com/pg-in-delhi-pppfr',
    keywords: ['PG in Delhi', 'Delhi PG', 'boys PG Delhi', 'girls PG Delhi', 'student accommodation Delhi']
  }
};

// Generic SEO for any other location
const getGenericSEO = (location, count) => {
  const locationTitle = location?.split(',')[0]?.trim() || location || 'PG';
  return {
    title: `${count} PG in ${locationTitle} | Verified PGs - AapkaPG`,
    description: `Find ${count} verified PGs in ${locationTitle}. Compare prices, amenities & photos. Zero brokerage, instant booking for students & professionals.`,
    canonicalUrl: `https://aapkapg.com/pg-in-${locationTitle.toLowerCase().replace(/ /g, '-')}-pppfr`,
    keywords: [`PG in ${locationTitle}`, `${locationTitle} PG`, 'student accommodation', 'rental']
  };
};

// Main SEO generator function
export const getSEOForLocation = (location, count) => {
  if (!location) {
    return HOME_SEO;
  }

  const locationLower = location.toLowerCase().trim();
  
  for (const [key, config] of Object.entries(LOCATION_SEO_CONFIG)) {
    if (locationLower.includes(key)) {
      return {
        title: config.title(count),
        description: config.description(count),
        canonicalUrl: config.canonicalUrl,
        keywords: config.keywords
      };
    }
  }
  
  return getGenericSEO(location, count);
};